import React from "react";
import {INVOICE_STYLE} from "../../constant";

export class ReceiptPrint extends React.Component {

  render() {
    const CurrentCartOrder = this.props.CurrentCartOrder || [];
    const CurrentCart = this.props.CurrentCart || [];
    const CompanyInfo = this.props.CompanyInfo || [];
    const styles =  INVOICE_STYLE
    // const truncate = (text = "", max = 20) =>
    //     text.length > max ? text.substring(0, max - 2) + ".." : text;
    return (
      <React.Fragment>
        <div style={styles.receipt}>

          {/* HEADER */}
          <div style={styles.center}>
            <div style={styles.bold}>{CompanyInfo.Name}</div>
            <div>{CompanyInfo.Address}</div>
            {CompanyInfo.Contact && <div>Tel: {CompanyInfo.Contact}</div>}
            {CompanyInfo.Email && <div>{CompanyInfo.Email}</div>}
          </div>

          <hr />

          {/* INFO */}
          <div style={styles.row}><span>Order:</span><span>{CurrentCart.order_id}</span></div>
          <div style={styles.row}><span>Table:</span><span>{CurrentCart.table}</span></div>
          <div style={styles.row}><span>Waiter:</span><span>{CurrentCart.waiter}</span></div>
          <div style={styles.row}><span>Date:</span><span>{CurrentCart.ordertime}</span></div>

          <hr />

          {/* ITEMS HEADER */}
          <div style={{ ...styles.row, ...styles.bold }}>
            <span style={{ width: "50%" }}>Item</span>
            <span style={{ width: "15%", textAlign: "right" }}>Qty</span>
            <span style={{ width: "35%", textAlign: "right" }}>Amt</span>
          </div>

          <hr />

          {/* ITEMS */}
          {CurrentCartOrder.map((item, i) => (
              <div key={i} style={styles.row}>
                <span style={{ width: "50%" }}>{item.name}</span>
                <span style={{ width: "15%", textAlign: "right" }}>{item.qty}</span>
                <span style={{ width: "35%", textAlign: "right" }}>
            {item.qty * item.price}
          </span>
              </div>
          ))}

          <hr />

          {/* TOTALS */}
          <div style={styles.row}><span>Subtotal</span><span>{CurrentCart.subtotal}</span></div>

          <div style={styles.row}>
            <span>Discount ({CurrentCart.discount?.percentage || 0}%)</span>
            <span>{CurrentCart.discount?.amount || 0}</span>
          </div>

          <div style={styles.row}>
            <span>Service ({CurrentCart.service || 0}%)</span>
            <span>{CurrentCart.charge}</span>
          </div>

          <hr />

          <div style={{ ...styles.row, ...styles.bold }}>
            <span>Total</span>
            <span>{CurrentCart.total}</span>
          </div>

          <hr />

          {/* PAYMENT */}
          <div style={styles.row}>
            <span>Payment</span>
            <span>{CurrentCart.payment?.type || "Other"}</span>
          </div>
          <div style={styles.row}><span>Tender</span><span>{CurrentCart.tender}</span></div>
          <div style={styles.row}><span>Change</span><span>{CurrentCart.change}</span></div>

          <hr />

          {/* FOOTER */}
          <div style={styles.center}>
            <div>Thank you!</div>
            <div>{CompanyInfo.Website}</div>
            <small>Not an official invoice. Collect original after payment.</small>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
